// extracted by mini-css-extract-plugin
export default {"button":"FloatButton_button__mgONv","icon":"FloatButton_icon__-6Oa7"};